// extracted by mini-css-extract-plugin
export default {"label":"ZogLtK","withTail":"rNM7m9","direction-left":"IB19_s","direction-right":"XEJhuy","indent-16":"UTAFfJ","indent-32":"YMpo4y","indent-40":"pnsB5C","indent-56":"Abqp22"};